// extracted by mini-css-extract-plugin
export default {"send-new-request":"styles_send-new-request__n+fLw","title":"styles_title__VX9j9","content-wrapper":"styles_content-wrapper__yFY4K","content-text":"styles_content-text__TKR9V"};